// extracted by mini-css-extract-plugin
export default {"container":"WagonsReportSummary_container__Aqikz"};